module.exports = __webpack_public_path__ + "static/media/fiends-academy-logotype.ca7ba7df.png";